module.exports = __webpack_public_path__ + "static/img/solution-3.694fbd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution-3.png
// module id = 3/7l
// module chunks = 0